module.exports = __webpack_public_path__ + "static/media/eirich-mixer-home-s.dcbb5703.webp";